class Position{
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}

export default Position;